export default {fields:{creator:{spreads:{Creator:{}},typenameResolver:'PartyTypenameResolver'}}}